import axios from "axios";

// const baseUrlDev = "https://api-uatnew.healthyrpm.com";
const baseUrlDev = "https://api-dhct-int-qa-app.carenow.healthcare/dhct";

export const apiAxios = axios.create({
  baseURL: baseUrlDev,
});

export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-one-int-qa-wrapper-app.carenow.healthcare");

export const cndWrapperURL = (url = "") =>
  new URL(url, "https://vc.cloudcayr-qa.careplix.com");

export const cndURL = (url = "") =>
  new URL(url, "https://api-int-qa.carenowdoc.com");
